import SingleModelInterface from '../../types/singleModelInterface'

export default function filterByCarNames(
    carNames: string[],
    allModels: SingleModelInterface[]
): SingleModelInterface[] {
    if (carNames.length) {
        return allModels.filter((model) => carNames.includes(model.name))
    }

    return allModels
}
